import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { RATIO_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const RatioMasterApi = createApi({
  reducerPath: "RatioMaster",
  baseQuery,
  tagTypes: ["RatioMaster"],
  endpoints: (builder) => ({
    getRatioMaster: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: RATIO_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: RATIO_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["RatioMaster"],
    }),
    getRatioMasterById: builder.query({
      query: (id) => {
        return {
          url: `${RATIO_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["RatioMaster"],
    }),
    addRatioMaster: builder.mutation({
      query: (payload) => ({
        url: RATIO_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["RatioMaster"],
    }),
    updateRatioMaster: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${RATIO_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["RatioMaster"],
    }),
    deleteRatioMaster: builder.mutation({
      query: (id) => ({
        url: `${RATIO_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RatioMaster"],
    }),
  }),
});

export const {
  useGetRatioMasterQuery,
  useGetRatioMasterByIdQuery,
  useAddRatioMasterMutation,
  useUpdateRatioMasterMutation,
  useDeleteRatioMasterMutation,
} = RatioMasterApi;

export default RatioMasterApi;
